module.exports = __webpack_public_path__ + "img/old.0fdfd54d.png";